import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/app/layouts/app.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/app/layouts/auth.vue").then(m => m.default || m)),
  "terms-and-conditions": defineAsyncComponent(() => import("/app/layouts/terms-and-conditions.vue").then(m => m.default || m))
}